import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { UserStore } from '@core/stores';
import { environment } from '@env/environment';

export const traceInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(UserStore);
  const sessionId = store.sessionId();

  const headers: Record<string, string> = {
    ...(!!sessionId ? { traceparent: sessionId } : {}),
    'app-version': environment.version,
  };

  return next(
    req.clone({
      setHeaders: headers,
    }),
  );
};
